import {Fragment, h} from "preact";
import s from "./priceBlock.module.css";
import {useAppContext} from "../../../../../contexts";

const PriceBlock = (props) => {
    // Destructured props
    const {data} = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <Fragment>
            <div className={s.priceBlock}>
                <h1 className={`${highContrast ? "highTitleThird" : ""}`}>
                    Investimento total:
                </h1>
                <p className={` ${highContrast ? "highLabelFirst" : ""}`}>
                    R$&nbsp;
                    {data.total}
                </p>
            </div>
        </Fragment>
    )
}

export default PriceBlock;
